export default class ChartFilterBuilder {
    constructor(getEntityFields, getResource) {
        this._getEntityFields = getEntityFields;
        this._getResource = getResource;
    }

    getAggregationDataSource({ includeCountUnique = true, includeMedian = true } = {}) {
        const r = this._getResource;
        const all = [
            { id: 'COUNT', name: r('AGGREGATOR_COUNT') },
            { id: 'COUNT_UNIQUE', name: r('AGGREGATOR_COUNT_UNIQUE') },
            { id: 'SUM', name: r('AGGREGATOR_SUM') },
            { id: 'AVERAGE', name: r('AGGREGATOR_AVERAGE') },
            { id: 'MIN', name: r('AGGREGATOR_MIN') },
            { id: 'MAX', name: r('AGGREGATOR_MAX') },
            { id: 'MEDIAN', name: r('AGGREGATOR_MEDIAN') }
        ];
        return all.filter(x =>
            (x.id !== 'COUNT_UNIQUE' || includeCountUnique) &&
            (x.id !== 'MEDIAN' || includeMedian)
        );
    }

    getColorPaletteDataSource() {
        const r = this._getResource;
        return [
            { id: 'default', name: r('PaletteDefault') },
            { id: 'pastel', name: r('PalettePastel') },
            { id: 'vivid', name: r('PaletteVivid') },
            { id: 'custom', name: r('PaletteCustom') }
        ];
    }

    getSortOrderDataSource() {
        const r = this._getResource;
        return [
            { id: 'asc', name: r('SortAscending') },
            { id: 'desc', name: r('SortDescending') }
        ];
    }

    toggleCustomColors(paletteSelectId, containerId) {
        let palette = $('#' + paletteSelectId).data('kendoComboBox').value();
        let container = document.getElementById(containerId);
        if (container) {
            container.style.display = palette === 'custom' ? '' : 'none';
        }
    }

    initCustomColorsPicker(containerId, chart) {
        this._ensureSwatchStyles();
        let listId = containerId + '-list';
        let addBtnId = containerId + '-add';
        let colors = (chart != null && Array.isArray(chart.customColors) && chart.customColors.length > 0)
            ? chart.customColors
            : ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0'];

        colors.forEach(color => {
            this.addCustomColorInput(listId, color);
        });

        let addBtn = document.getElementById(addBtnId);
        if (addBtn && !addBtn.classList.contains('xp-cc-add')) addBtn.classList.add('xp-cc-add');
        addBtn.addEventListener('click', () => {
            this.addCustomColorInput(listId, '#000000');
        });

        let palette = (chart != null) ? (chart.colorPalette || 'default') : 'default';
        if (palette === 'custom') {
            document.getElementById(containerId).style.display = '';
        }
    }

    addCustomColorInput(listId, color) {
        let wrapper = document.createElement('div');
        wrapper.className = 'xp-cc-swatch';
        let input = document.createElement('input');
        input.type = 'color';
        input.value = color;
        let removeBtn = document.createElement('span');
        removeBtn.className = 'xp-cc-remove';
        removeBtn.innerHTML = '&times;';
        removeBtn.addEventListener('click', () => {
            wrapper.remove();
        });
        wrapper.appendChild(input);
        wrapper.appendChild(removeBtn);
        let list = document.getElementById(listId);
        let addBtn = list.querySelector('button');
        list.insertBefore(wrapper, addBtn);
    }

    _ensureSwatchStyles() {
        if (document.getElementById('xp-cc-swatch-styles')) return;

        let style = document.createElement('style');
        style.id = 'xp-cc-swatch-styles';
        style.textContent =
            '.xp-cc-swatch {' +
                'position:relative;display:inline-flex;align-items:center;' +
            '}' +
            '.xp-cc-swatch input[type="color"] {' +
                'width:36px;height:36px;padding:2px;border:1px solid #ccc;border-radius:4px;' +
                'cursor:pointer;transition:border-color 0.15s ease;' +
            '}' +
            '.xp-cc-swatch input[type="color"]:hover {' +
                'border-color:var(--theme-primary-700);' +
            '}' +
            '.xp-cc-remove {' +
                'position:absolute;top:-6px;right:-6px;' +
                'width:16px;height:16px;border-radius:50%;' +
                'background:#fff;color:#666;border:1px solid #ccc;' +
                'display:flex;align-items:center;justify-content:center;' +
                'font-size:12px;line-height:1;cursor:pointer;opacity:0;' +
                'transition:opacity 0.15s ease,color 0.15s ease,border-color 0.15s ease;' +
            '}' +
            '.xp-cc-swatch:hover .xp-cc-remove {' +
                'opacity:1;' +
            '}' +
            '.xp-cc-remove:hover {' +
                'color:#d9534f;border-color:#d9534f;' +
            '}' +
            '.xp-cc-add {' +
                'width:36px;height:36px;border:1px dashed #bbb !important;' +
                'background:transparent !important;color:#888 !important;' +
                'border-radius:4px !important;padding:0 !important;' +
                'display:inline-flex;align-items:center;justify-content:center;' +
                'font-size:18px !important;line-height:1;cursor:pointer;' +
                'transition:border-color 0.15s ease,color 0.15s ease;' +
            '}' +
            '.xp-cc-add:hover {' +
                'border-color:var(--theme-primary-700) !important;' +
                'color:var(--theme-primary-700) !important;' +
                'background:transparent !important;' +
            '}';

        document.head.appendChild(style);
    }

    getCustomColors(containerId) {
        let list = document.getElementById(containerId + '-list');
        if (!list) return [];
        let inputs = list.querySelectorAll('input[type="color"]');
        let colors = [];
        inputs.forEach(input => {
            colors.push(input.value);
        });
        return colors;
    }

    sanitizeRules(rules) {
        if (rules == null || typeof rules !== 'object') return null;
        if (Array.isArray(rules.rules)) {
            let cleaned = rules.rules
                .map(r => this.sanitizeRules(r))
                .filter(r => r != null);
            if (cleaned.length === 0) return null;
            return Object.assign({}, rules, { rules: cleaned });
        }
        if (rules.id == null || rules.id === '') return null;
        return rules;
    }

    getValueFieldOptions() {
        let result = '';
        let fields = this._getEntityFields() || [];
        fields.forEach((entityField) => {
            result += '<option value="' + entityField.FieldName + '">' + entityField.FieldName + '</option>';
        });
        return result;
    }

    getConditionOperatorType(entityField) {
        switch (entityField.DataType) {
            case 'STRING': return 'string';
            case 'TIMESTAMP': return 'datetime';
            case 'INTEGER': return 'integer';
            case 'BOOLINT': return 'integer';
            case 'NUMERIC': return 'double';
            case 'BOOLEAN': return 'boolean';
            case 'DATE': return 'date';
            default: return 'string';
        }
    }

    getConditionFilter(entityField, prefix, labelPrefix) {
        let filter = {
            id: prefix + entityField.FieldName,
            label: entityField.FieldName + labelPrefix,
            type: this.getConditionOperatorType(entityField),
            operators: this.getFilterOperator(entityField),
            isInitialized: false,
            input: (rule, name) => {
                rule.filter.isInitialized = false;
                if (rule.operator.type == 'between') {
                    if (name.indexOf('value_0') > 0) {
                        var $container = rule.$el.find('.rule-value-container');

                        $container.on('change', '[name=' + name + '_1]', (evt) => {
                            var h = '';

                            switch ($(evt.currentTarget).val()) {
                                case 'Value':
                                    h = '<input class="form-control"/>';
                                    $container.find('[name$=_3]').html(h).toggle(true);
                                    $container.find('[name$=_2]').toggle(false);
                                    this.initializeFilter(rule, entityField, rule.$el.find('.rule-value-container [name$=_3]').find('input'));
                                    rule.filter.isInitialized = true;
                                    break;
                                case 'Field':
                                    h = this.getValueFieldOptions();
                                    $container.find('[name$=_2]').html(h).toggle(true).trigger('change');
                                    $container.find('[name$=_3]').toggle(false);
                                    break;
                            }
                        });

                        return `<select class="form-control" name="` + name + `_1">
                                    <option value="Value">Value</option>
                                </select>
                                <select class="form-control" name="`+ name + `_2" style="display:none; margin-left: 0.5rem;"></select>
                                    <div name="`+ name + `_3" style="margin-left: 0.5rem;"><input class="form-control"/></div>`;
                    } else {
                        var $container = rule.$el.find('.rule-value-container');

                        $container.on('change', '[name=' + name + '_4]', (evt) => {
                            var h = '';

                            switch ($(evt.currentTarget).val()) {
                                case 'Value':
                                    h = '<input class="form-control"/>';
                                    $container.find('[name$=_6]').html(h).toggle(true);
                                    $container.find('[name$=_5]').toggle(false);
                                    this.initializeFilter(rule, entityField, rule.$el.find('.rule-value-container [name$=_6]').find('input'));
                                    rule.filter.isInitialized = true;
                                    break;
                                case 'Field':
                                    h = this.getValueFieldOptions();
                                    $container.find('[name$=_5]').html(h).toggle(true).trigger('change');
                                    $container.find('[name$=_6]').toggle(false);
                                    break;
                            }
                        });

                        return `<select class="form-control" name="` + name + `_4">
                                    <option value="Value">Value</option>
                                </select>
                                <select class="form-control" name="`+ name + `_5" style="display:none; margin-left: 0.5rem;"></select>
                                <div name="`+ name + `_6" style="margin-left: 0.5rem;"><input class="form-control"/></div>`;
                    }
                } else {
                    var $container = rule.$el.find('.rule-value-container');

                    $container.on('change', '[name=' + name + '_1]', (evt) => {
                        var h = '';

                        switch ($(evt.currentTarget).val()) {
                            case 'Value':
                                h = '<input class="form-control"/>';
                                $container.find('[name$=_3]').html(h).toggle(true);
                                $container.find('[name$=_2]').toggle(false);
                                this.initializeFilter(rule, entityField, rule.$el.find('.rule-value-container [name$=_3]').find('input'));
                                rule.filter.isInitialized = true;
                                break;
                            case 'Field':
                                h = this.getValueFieldOptions();
                                $container.find('[name$=_2]').html(h).toggle(true).trigger('change');
                                $container.find('[name$=_3]').toggle(false);
                                break;
                        }
                    });

                    return `<select class="form-control" name="` + name + `_1">
                                <option value="Value">Value</option>
                            </select>
                            <select class="form-control" name="`+ name + `_2" style="display:none; margin-left: 0.5rem;"></select>
                                    <div name="`+ name + `_3" style="margin-left: 0.5rem;"><input class="form-control"/></div>`;
                }
            },
            valueGetter: (rule) => {
                return this.filterValueGetter(rule, entityField);
            },
            valueSetter: (rule, value) => {
                if (rule.operator.nb_inputs > 0) {
                    if (value != null && value.trim() != '') {
                        var val = JSON.parse(value);
                        if (rule.operator.type == 'between') {
                            rule.$el.find('.rule-value-container [name$=_1]').val(val.min.type).trigger('change');

                            if (val.min.type == 'Field') {
                                rule.$el.find('.rule-value-container [name$=_2]').val(val.min.value).trigger('change');
                            } else {
                                this.setFilterValue(entityField, rule.$el.find('.rule-value-container [name$=_3]').find('input'), val.min.value);
                            }

                            rule.$el.find('.rule-value-container [name$=_4]').val(val.max.type).trigger('change');

                            if (val.max.type == 'Field') {
                                rule.$el.find('.rule-value-container [name$=_5]').val(val.max.value).trigger('change');
                            } else {
                                this.setFilterValue(entityField, rule.$el.find('.rule-value-container [name$=_6]').find('input'), val.max.value);
                            }
                        } else {
                            rule.$el.find('.rule-value-container [name$=_1]').val(val.type).trigger('change');
                            if (val.type == 'Field') {
                                rule.$el.find('.rule-value-container [name$=_2]').val(val.value).trigger('change');
                            } else {
                                this.setFilterValue(entityField, rule.$el.find('.rule-value-container [name$=_3]').find('input'), val.value);
                            }
                        }
                    }
                }
            }
        }

        return filter;
    }

    getFilterOperator(entityField) {
        switch (entityField.DataType) {
            case 'BYTEA':
            case 'GEOMETRY':
            case 'BOOLEAN':
            case 'BOOLINT':
            case 'STRING': return ['equal', 'not_equal', 'is_null', 'is_not_null'];
            case 'NUMERIC':
            case 'INTEGER':
            case 'DATE':
            case 'TIMESTAMP': return ['equal', 'not_equal', 'is_null', 'is_not_null', 'between', 'less', 'less_or_equal', 'greater', 'greater_or_equal'];
        }
    }

    initializeFilter(rule, entityField, selector) {
        switch (entityField.DataType) {
            case 'INTEGER': {
                selector.parent().css('padding-top', '0');
                selector.kendoNumericTextBox({
                    format: "0",
                    decimals: 0,
                    change: (evt) => {
                        rule._updating_value = true;
                        rule.value = this.filterValueGetter(rule, entityField);
                    }
                });
            };
                break;
            case 'NUMERIC': {
                selector.parent().css('padding-top', '0');
                selector.kendoNumericTextBox({
                    change: (evt) => {
                        rule._updating_value = true;
                        rule.value = this.filterValueGetter(rule, entityField);
                    }
                });
            };
                break;
            case 'BOOLEAN':
            case 'BOOLINT': {
                selector.parent().css('padding-top', '0.5rem');
                selector.removeClass('form-control');
                selector.kendoSwitch({
                    change: (evt) => {
                        rule._updating_value = true;
                        rule.value = this.filterValueGetter(rule, entityField);
                    }
                });
            };
                break;
            case 'DATE': {
                selector.parent().css('padding-top', '0');
                selector.kendoDatePicker();
            }
                break;
            case 'TIMESTAMP': {
                selector.parent().css('padding-top', '0');
                selector.kendoDateTimePicker();
            }
                break;
            default: selector.parent().css('padding-top', '0');
                break;
        }
    }

    filterValueGetter(rule, entityField) {
        if (!rule.filter.isInitialized) {
            if (rule.operator.type == 'between') {
                this.initializeFilter(rule, entityField, rule.$el.find('.rule-value-container [name$=_3]').find('input'));
                this.initializeFilter(rule, entityField, rule.$el.find('.rule-value-container [name$=_6]').find('input'));
                rule.filter.isInitialized = true;
            }
            else {
                this.initializeFilter(rule, entityField, rule.$el.find('.rule-value-container [name$=_3]').find('input'));
                rule.filter.isInitialized = true;
            }
        }

        if (rule.operator.type == 'between') {
            let minType = rule.$el.find('.rule-value-container [name$=_1]').val();
            let maxType = rule.$el.find('.rule-value-container [name$=_4]').val();
            let result = {
                min: {
                    type: minType,
                    value: minType == 'Field' ? rule.$el.find('.rule-value-container [name$=_2]').val() : this.getFilterValue(entityField, rule.$el.find('.rule-value-container [name$=_3]').find('input'))
                },
                max: {
                    type: maxType,
                    value: minType == 'Field' ? rule.$el.find('.rule-value-container [name$=_5]').val() : this.getFilterValue(entityField, rule.$el.find('.rule-value-container [name$=_6]').find('input'))
                }
            };
            return JSON.stringify(result);
        } else {
            let type = rule.$el.find('.rule-value-container [name$=_1]').val();
            let result = {
                type: type,
                value: type == 'Field' ? rule.$el.find('.rule-value-container [name$=_2]').val() : this.getFilterValue(entityField, rule.$el.find('.rule-value-container [name$=_3]').find('input'))
            };
            return JSON.stringify(result);
        }
    }

    getFilterValue(entityField, selector) {
        switch (entityField.DataType) {
            case 'INTEGER': return ($(selector[1]).data('kendoNumericTextBox') != null ? $(selector[1]).data('kendoNumericTextBox').value() : null);
            case 'NUMERIC': return ($(selector[1]).data('kendoNumericTextBox') != null ? $(selector[1]).data('kendoNumericTextBox').value() : null);
            case 'BOOLEAN': return (selector.data('kendoSwitch') != null ? selector.data('kendoSwitch').check() : null);
            case 'BOOLINT': return (selector.data('kendoSwitch') != null ? (selector.data('kendoSwitch').check() ? 1 : 0) : null);
            case 'DATE': return (selector.data('kendoDatePicker') != null ? this.dateToISOString(selector.data('kendoDatePicker').value()) : null);
            case 'TIMESTAMP': return (selector.data('kendoDateTimePicker') != null ? this.dateToISOString(selector.data('kendoDateTimePicker').value()) : null);
            default: return selector.val();
        }
    }

    dateToISOString(date) {
        if (date == null) {
            return null;
        }

        let year = date.getFullYear();
        let month = this.padDatePart(date.getMonth() + 1);
        let day = this.padDatePart(date.getDate());
        let hours = this.padDatePart(date.getHours());
        let minutes = this.padDatePart(date.getHours());
        let seconds = this.padDatePart(date.getSeconds());

        return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds + '.000Z';
    }

    padDatePart(part) {
        if (part < 10) {
            return '0' + part;
        } else {
            return part;
        }
    }

    setFilterValue(entityField, selector, value) {
        switch (entityField.DataType) {
            case 'INTEGER': $(selector[1]).data('kendoNumericTextBox').value(value);
                break;
            case 'NUMERIC': $(selector[1]).data('kendoNumericTextBox').value(value);
                break;
            case 'BOOLEAN': selector.data('kendoSwitch').check(value);
                break;
            case 'BOOLINT': selector.data('kendoSwitch').check(value == 1);
                break;
            case 'DATE': selector.data('kendoDatePicker').value(new Date(value));
                break;
            case 'TIMESTAMP': selector.data('kendoDateTimePicker').value(new Date(value));
                break;
            case 'STRING': selector.val(value);
                break;
            default: break;
        }
    }
}
